import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [openModal, setOpenModal] = useState<ModalType>(null);
  const closeModal = () => setOpenModal(null);
  return <>
      <footer className="bg-[#1a1a1a] text-[#F5F0E8]/60 py-16 border-t border-[#D4AF37]/10" data-id="element-117">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-118">
          <p className="text-[#F5F0E8] font-bold tracking-widest uppercase mb-8" data-id="element-119">
            © {new Date().getFullYear()} – Rituales de Pies Ancestrales. Todos
            los derechos reservados.
          </p>

          <div className="bg-white/5 p-6 rounded-2xl border border-white/5 max-w-4xl mx-auto mb-8 text-left" data-id="element-120">
            <p className="font-bold text-[#D4AF37] mb-2 flex items-center gap-2" data-id="element-121">
              ⚠️ Aviso Importante:
            </p>
            <p className="text-xs leading-relaxed" data-id="element-122">
              El contenido de este sistema son prácticas tradicionales de
              bienestar y espiritualidad. NO sustituyen tratamientos médicos o
              psicológicos profesionales. Los resultados pueden variar de
              persona a persona. No garantizamos cura de enfermedades ni
              resultados específicos. Estas prácticas han sido utilizadas
              durante siglos para promover equilibrio energético y sensación de
              bienestar.
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-xs" data-id="element-123">
            <button type="button" onClick={() => setOpenModal('privacy')} className="hover:text-[#D4AF37] transition-colors underline-offset-4 hover:underline" data-id="element-124">
              Política de privacidad
            </button>
            <button type="button" onClick={() => setOpenModal('terms')} className="hover:text-[#D4AF37] transition-colors underline-offset-4 hover:underline" data-id="element-125">
              Términos y condiciones
            </button>
            <a href="#" className="hover:text-[#D4AF37] transition-colors" data-id="element-126">
              Garantía de devolución
            </a>
          </div>
        </div>
      </footer>

      {openModal && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={closeModal} role="dialog" aria-modal="true" data-id="element-127">
          <div className="relative bg-[#1a1a1a] border border-[#D4AF37]/30 rounded-2xl max-w-2xl w-full max-h-[85vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-128">
            <button type="button" onClick={closeModal} aria-label="Cerrar" className="absolute top-4 right-4 text-[#F5F0E8]/60 hover:text-[#D4AF37] transition-colors" data-id="element-129">
              <XIcon className="w-6 h-6" data-id="element-130" />
            </button>

            <div className="p-8 sm:p-10" data-id="element-131">
              {openModal === 'privacy' ? <>
                  <h2 className="text-2xl font-bold text-[#D4AF37] mb-6" data-id="element-132">
                    Política de Privacidad
                  </h2>
                  <div className="space-y-4 text-sm text-[#F5F0E8]/80 leading-relaxed" data-id="element-133">
                    <p data-id="element-134">
                      En Rituales de Pies Ancestrales valoramos y respetamos tu
                      privacidad. Esta política explica cómo recopilamos, usamos
                      y protegemos tu información personal.
                    </p>
                    <div data-id="element-135">
                      <h3 className="font-bold text-[#F5F0E8] mb-2" data-id="element-136">
                        1. Información que recopilamos
                      </h3>
                      <p data-id="element-137">
                        Recopilamos únicamente la información que tú nos
                        proporcionas al realizar una compra: nombre, correo
                        electrónico y datos de pago procesados de forma segura
                        por nuestros proveedores autorizados.
                      </p>
                    </div>
                    <div data-id="element-138">
                      <h3 className="font-bold text-[#F5F0E8] mb-2" data-id="element-139">
                        2. Uso de la información
                      </h3>
                      <p data-id="element-140">
                        Utilizamos tus datos exclusivamente para procesar tu
                        compra, enviarte el material adquirido y comunicarnos
                        contigo sobre tu pedido. No compartimos tu información
                        con terceros con fines comerciales.
                      </p>
                    </div>
                    <div data-id="element-141">
                      <h3 className="font-bold text-[#F5F0E8] mb-2" data-id="element-142">
                        3. Seguridad
                      </h3>
                      <p data-id="element-143">
                        Implementamos medidas de seguridad técnicas y
                        organizativas para proteger tu información personal
                        contra accesos no autorizados, pérdida o alteración.
                      </p>
                    </div>
                    <div data-id="element-144">
                      <h3 className="font-bold text-[#F5F0E8] mb-2" data-id="element-145">
                        4. Tus derechos
                      </h3>
                      <p data-id="element-146">
                        Tienes derecho a acceder, rectificar o solicitar la
                        eliminación de tus datos personales en cualquier
                        momento.
                      </p>
                    </div>
                    <div data-id="element-147">
                      <h3 className="font-bold text-[#F5F0E8] mb-2" data-id="element-148">
                        5. Cookies
                      </h3>
                      <p data-id="element-149">
                        Usamos cookies para mejorar tu experiencia de navegación
                        y analizar el tráfico del sitio. Puedes desactivarlas
                        desde la configuración de tu navegador.
                      </p>
                    </div>
                  </div>
                </> : <>
                  <h2 className="text-2xl font-bold text-[#D4AF37] mb-6" data-id="element-150">
                    Términos y Condiciones
                  </h2>
                  <div className="space-y-4 text-sm text-[#F5F0E8]/80 leading-relaxed" data-id="element-151">
                    <p data-id="element-152">
                      Al adquirir nuestro sistema aceptás los siguientes
                      términos y condiciones de uso.
                    </p>
                    <div data-id="element-153">
                      <h3 className="font-bold text-[#F5F0E8] mb-2" data-id="element-154">
                        1. Naturaleza del producto
                      </h3>
                      <p data-id="element-155">
                        El producto consiste en material digital descargable de
                        carácter informativo y espiritual. No constituye
                        asesoramiento médico ni psicológico profesional.
                      </p>
                    </div>
                    <div data-id="element-156">
                      <h3 className="font-bold text-[#F5F0E8] mb-2" data-id="element-157">
                        2. Licencia de uso
                      </h3>
                      <p data-id="element-158">
                        La compra otorga una licencia personal e intransferible.
                        Está prohibida la reproducción, distribución o reventa
                        total o parcial del contenido sin autorización expresa.
                      </p>
                    </div>
                    <div data-id="element-159">
                      <h3 className="font-bold text-[#F5F0E8] mb-2" data-id="element-160">
                        3. Entrega
                      </h3>
                      <p data-id="element-161">
                        El acceso al material se entrega de forma digital
                        inmediatamente luego de confirmado el pago, al correo
                        electrónico proporcionado durante la compra.
                      </p>
                    </div>
                    <div data-id="element-162">
                      <h3 className="font-bold text-[#F5F0E8] mb-2" data-id="element-163">
                        4. Garantía y devoluciones
                      </h3>
                      <p data-id="element-164">
                        Ofrecemos garantía de devolución según los términos
                        descritos en nuestra sección de Garantía. Las
                        solicitudes deben realizarse dentro del plazo
                        establecido.
                      </p>
                    </div>
                    <div data-id="element-165">
                      <h3 className="font-bold text-[#F5F0E8] mb-2" data-id="element-166">
                        5. Limitación de responsabilidad
                      </h3>
                      <p data-id="element-167">
                        No nos hacemos responsables por resultados específicos
                        derivados de la aplicación de las prácticas compartidas,
                        ya que dependen del compromiso individual de cada
                        usuario.
                      </p>
                    </div>
                    <div data-id="element-168">
                      <h3 className="font-bold text-[#F5F0E8] mb-2" data-id="element-169">
                        6. Modificaciones
                      </h3>
                      <p data-id="element-170">
                        Nos reservamos el derecho de modificar estos términos en
                        cualquier momento. Los cambios serán publicados en esta
                        misma página.
                      </p>
                    </div>
                  </div>
                </>}
            </div>
          </div>
        </div>}
    </>;
}